// PDP - Add to cart 가격 업데이트
(() => {
  const initialized = new WeakSet();

  function initButtonPrice(container = document) {
    container.querySelectorAll('[id^="MainProduct-"]').forEach((section) => {
      if (initialized.has(section)) return;

      const picker = section.querySelector('variant-selects, variant-radios');
      const variantJSON = picker?.querySelector(
        'script[type="application/json"]'
      );
      const button = section.querySelector('.product-form__submit');
      const form = button?.closest('form');

      if (!variantJSON || !button || !form) return;

      const variants = JSON.parse(variantJSON.textContent);
      initialized.add(section);

      function updatePrice() {
        const priceElement = button.querySelector('.b7-product-button__price');
        if (!priceElement || typeof formatMoney !== 'function') return;

        const variantId = form.querySelector('input[name="id"]')?.value;
        const variant = variants.find(
          (item) => String(item.id) === variantId
        );

        // 존재하지 않는 옵션 조합에서는 이전 가격 숨기기
        const unavailable =
          Object.prototype.hasOwnProperty.call(picker, 'currentVariant') &&
          !picker.currentVariant;

        priceElement.hidden = unavailable;
        if (unavailable || !variant) return;

        const subscriptionRadio = section.querySelector(
          '.shopify_subscriptions_app_container ' +
          'input[data-radio-type="selling_plan"]:checked'
        );

        let priceText;

        if (subscriptionRadio) {
          // 구독 선택 시 앱에서 제공하는 구독 가격 사용
          priceText = subscriptionRadio.dataset.variantPrice;
          if (!priceText) return;
        } else {
          // 일반 구매 시 선택한 variant 가격 사용
          const formatted = document.createElement('span');
          formatted.innerHTML = formatMoney(variant.price);
          priceText = formatted.textContent;
        }

        priceText = priceText.replace(/\.00(?=\D|$)/, '');
        
        if (priceElement.textContent !== priceText) {
          priceElement.textContent = priceText;
        }
      }

      let frame;

      function scheduleUpdate() {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(updatePrice);
      }

      section.addEventListener('change', scheduleUpdate);

      // 기존 구독 코드가 버튼 가격을 다시 써도 현재 가격으로 갱신
      const observer = new MutationObserver(scheduleUpdate);

      observer.observe(section, {
        subtree: true,
        childList: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['data-variant-price'],
      });

      scheduleUpdate();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initButtonPrice());
  } else {
    initButtonPrice();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initButtonPrice(event.target);
  });
})();